var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("List")]),_vm._l((_vm.item),function(child){return _c('content-block',{key:_vm.getId(child),attrs:{"item":child,"parent":_vm.item,"removable":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }